export const backgroundImageStyles = {
  backgroundImage: 'url(' + process.env.PUBLIC_URL + '/img/líneas_izq.svg)',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
};
